"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ValueSet_Include = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_ValueSet_Concept_1 = require("./RTTI_ValueSet_Concept");
var RTTI_ValueSet_Filter_1 = require("./RTTI_ValueSet_Filter");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
exports.RTTI_ValueSet_Include = t.recursion('IValueSet_Include', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        system: RTTI_uri_1.RTTI_uri,
        _system: RTTI_Element_1.RTTI_Element,
        version: t.string,
        _version: RTTI_Element_1.RTTI_Element,
        concept: t.array(RTTI_ValueSet_Concept_1.RTTI_ValueSet_Concept),
        filter: t.array(RTTI_ValueSet_Filter_1.RTTI_ValueSet_Filter),
        valueSet: t.array(RTTI_canonical_1.RTTI_canonical)
    });
});
//# sourceMappingURL=RTTI_ValueSet_Include.js.map